/* ==========================================================================
   Satjeevan — "The Bilona Method" V2 Story Video controls
   (bilona-method-v2-video.js)

   Custom play/pause (centered, tap-to-reveal) and mute controls for the
   optional Story Video (replaces the Story Image when a merchant sets one
   in the theme editor). Independent from bilona-method-v2.js (the
   filmstrip autoplay) — only loaded on pages where a video is actually
   configured.

   No dependencies — vanilla JS only, no globals.
   ========================================================================== */

(function () {
  'use strict';

  var INIT_ATTR = 'data-sj-bmv2-video-init';

  function initVideo(wrap) {
    if (wrap.hasAttribute(INIT_ATTR)) return;
    wrap.setAttribute(INIT_ATTR, '1');

    var video = wrap.querySelector('[data-sj-bmv2-video]');
    var playBtn = wrap.querySelector('[data-sj-bmv2-video-playpause]');
    var muteBtn = wrap.querySelector('[data-sj-bmv2-video-mute]');
    if (!video) return;

    var iconPlay = playBtn ? playBtn.querySelector('.sj-bmv2-video-icon-play') : null;
    var iconPause = playBtn ? playBtn.querySelector('.sj-bmv2-video-icon-pause') : null;
    var iconVolumeOn = muteBtn ? muteBtn.querySelector('.sj-bmv2-video-icon-volume-on') : null;
    var iconVolumeOff = muteBtn ? muteBtn.querySelector('.sj-bmv2-video-icon-volume-off') : null;

    var CONTROLS_HIDE_DELAY = 2000;
    var hideControlsTimer = null;

    function showControls() {
      wrap.classList.add('is-controls-visible');
      clearTimeout(hideControlsTimer);
      hideControlsTimer = setTimeout(function () {
        wrap.classList.remove('is-controls-visible');
      }, CONTROLS_HIDE_DELAY);
    }

    function updatePlayState() {
      var playing = !video.paused && !video.ended;
      wrap.classList.toggle('is-playing', playing);
      if (iconPlay) iconPlay.style.display = playing ? 'none' : 'block';
      if (iconPause) iconPause.style.display = playing ? 'block' : 'none';
      if (playBtn) playBtn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    }

    function togglePlay() {
      if (video.paused || video.ended) {
        video.play();
      } else {
        video.pause();
      }
    }

    // A single click anywhere on the video toggles play/pause and reveals
    // the center play/pause button + overlay for a couple of seconds.
    video.addEventListener('click', function () {
      togglePlay();
      showControls();
    });
    video.addEventListener('play', updatePlayState);
    video.addEventListener('pause', updatePlayState);
    video.addEventListener('ended', updatePlayState);

    if (playBtn) {
      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        togglePlay();
        showControls();
      });
    }

    if (muteBtn) {
      function updateVolumeState() {
        var muted = video.muted || video.volume === 0;
        if (iconVolumeOn) iconVolumeOn.style.display = muted ? 'none' : 'block';
        if (iconVolumeOff) iconVolumeOff.style.display = muted ? 'block' : 'none';
        muteBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      }

      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        if (!video.muted && video.volume === 0) video.volume = 1;
      });

      video.addEventListener('volumechange', updateVolumeState);
      updateVolumeState();
    }

    updatePlayState();
  }

  function init() {
    document.querySelectorAll('[data-sj-bmv2-video-wrap]').forEach(initVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme Editor live-reload support
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-sj-bmv2-video-wrap]')) {
      init();
    }
  });
})();
